let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3hWkg")).then(() => parcelRequire('i8e1d'));